var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequester(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7542 13.9999C18.9962 13.9999 20.003 15.0068 20.003 16.2488V17.1673C20.003 17.7406 19.8238 18.2996 19.4905 18.7661C17.9446 20.9294 15.4203 22.0011 12 22.0011C8.57903 22.0011 6.05607 20.9289 4.51391 18.7646C4.18195 18.2987 4.00354 17.7408 4.00354 17.1688V16.2488C4.00354 15.0068 5.0104 13.9999 6.25242 13.9999H17.7542ZM12 2.00462C14.7614 2.00462 17 4.2432 17 7.00462C17 9.76605 14.7614 12.0046 12 12.0046C9.23857 12.0046 7 9.76605 7 7.00462C7 4.2432 9.23857 2.00462 12 2.00462Z",
    fill: "#605E5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequester);
export default __webpack_public_path__ + "static/media/requester.625c2fe240d25ffcc76bab1bd94e278a.svg";
export { ForwardRef as ReactComponent };